<template>
  <section>
      <div v-if="!loading">
      <button
        :disabled="checkDisabled"
        v-on:click="loginSubmit"
        class="btn btn-fill mt-2 btn-block btn-primary"
      >
        {{ $t("LOGIN") }}
      </button>
    </div>
    <div class="p-4 text-center" v-if="loading">
      <div v-if="hintMessage == 'outstandingTransaction'">
        <div v-if="!showOnThisDevice">
          1. {{ $t("BANKID_SE.PROCESS.outstandingTransaction.step1") }}.<br />
          2. {{ $t("BANKID_SE.PROCESS.outstandingTransaction.step2") }}.<br />
          3. {{ $t("BANKID_SE.PROCESS.outstandingTransaction.step3") }}.<br />
          4. {{ $t("BANKID_SE.PROCESS.outstandingTransaction.step4") }}.<br />

          <qrcode-vue
            class="qrcode mt-2 mb-4"
            v-if="autoStartToken != ''"
            :value="bankidUrl"
            :key="autoStartToken"
            size="200" margin="2"
            level="H"
          ></qrcode-vue>
          
          <a variant="primary" target="_blank" :href="bankidUrlDevice">{{ $t("SAME_DEVICE") }}</a>

        </div>
        <div class="mt-2 mb-2" v-if="showOnThisDevice">
           <a variant="primary" class="btn btn-primary btn-fill text-white" target="_blank"  :href="bankidUrlDevice">{{ $t("SAME_DEVICE") }}</a>
          <br />
          <br />
          <a href="#" @click.prevent="otherDevice"> {{ $t("OTHER_DEVICE") }}</a>
        </div>
      </div>

      <div v-if="hintMessage != 'outstandingTransaction'">
        <h5>{{ statusMessage }}</h5>
      </div>

      <button v-on:click="cancelSubmit" class="mt-4 btn btn-secondary">
        {{ $t("CANCEL") }}
      </button>
    </div>
  </section>
</template>
<script>
import mobileDetect from "mobile-device-detect";
import QrcodeVue from "qrcode.vue";
export default {
  components: { QrcodeVue },
  props: ["loginInfo"],
  data() {
    return {
      device: mobileDetect,
      loading: true,
      autoStartToken: "",
      statusMessage: "",
      timer: "",
      auth_uuid: "",
      qrCode: "",
      hintMessage: "",
      errorMessage: "",
      showOnThisDevice: false
    };
  },
  methods: {
    otherDevice: function() {
      this.showOnThisDevice = false;
    },
    reset: function() {
      clearTimeout(this.timer);
      this.loading = false;
      this.autoStartToken = "";
      this.showOnThisDevice = this.device.isMobile;
      this.$emit("loading", false);
    },
    cancelSubmit: async function() {
      event.preventDefault();
      this.reset();
      await this.$http
        .get(this.user.hostname + "/authenticate/cancel/" + this.auth_uuid);      
    },
    loginSubmit: async function(event) {
      event.preventDefault();
      this.loading = true;
      let self = this;
      self.$emit("loading", true);
      this.$http
        .post(this.user.hostname + "/authenticate", {
          email: this.user.email,
          auth_type: this.loginInfo.auth_type,
          auth_method: this.loginInfo.auth_method,
          client: "teams"
        })
        .then(function(result) {
          self.statusMessage = "";
          self.auth_uuid = result.data.auth_uuid;
          self.autoStartToken = result.data.autoStartToken;
          if(result.data.qrCode != undefined)
          {
            self.qrCode = result.data.qrCode;
          }
          self.checkStatus();
        })
        .catch(function(error) {
          self.reset();
          if(error.toString() == "Error: fail_4_4") return;
          if (error.response != undefined) {
            self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
          }
        });
    },
    checkStatus: function() {
      let self = this;
      if(this.autoStartToken != "")
      {
        this.loading = true;
        this.$http
          .get(this.user.hostname + "/authenticate/status/" + this.auth_uuid)
          .then(function(result) {
            if (result.status == 200) {
              clearTimeout(self.timer);
              self.verifyAuthentication();
            }
            if (result.status == 202) {
              if(result.data.hintCode != undefined)
              {
                if(result.data.hintCode == "startFailed")
                {                
                  self.reset();
                  //self.$noty.error(self.$t("BANKID_SE.ERROR.startFailed"));
                }else{
                  self.qrCode = result.data.qrCode;         
                  self.hintMessage = result.data.hintCode;
                  self.statusMessage = self.$t("BANKID_SE.PROCESS." + result.data.hintCode);
                }
              }else{
                if(result.data != "")
                {
                  if(result.data == "startFailed")
                  {                
                    self.reset();
                    //self.$noty.error(self.$t("BANKID_SE.ERROR.startFailed"));
                  }else{
                    self.hintMessage = result.data;              
                    self.statusMessage = self.$t("BANKID_SE.PROCESS." + result.data);
                  }
                }
              }
              self.timer = setTimeout(function() {
                self.checkStatus();
              }, 1500);
            }
          })
          .catch(function(error) {
            self.hintMessage = error.response.data;
            self.reset();
            if(error.toString() == "Error: fail_4_4") return;
            self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
          });
      }
    },
    verifyAuthentication: function() {
      let self = this;
      this.$http
        .get(this.user.hostname + "/authenticate/result/" + this.auth_uuid)
        .then(function(result) {     
          self.$emit('authenticated', result.data.token);
        })
        .catch(function(error) {
          self.reset();
          if(error.toString() == "Error: fail_4_4") return;
          self.$noty.error(self.$t("ERROR.CANNOT_LOGIN"));
        });
    },
  },
  computed: {
    bankidUrlDevice() {
      return "bankid:///?autostarttoken=" + this.autoStartToken + "&redirect=null";
    },
    bankidUrl() {
      if(this.qrCode == "")
      {
        return "bankid:///?autostarttoken=" + this.autoStartToken + "&redirect=null";
      }else{
        return this.qrCode;
      }
    },
    checkDisabled: function() {
      return this.user.email == "";
    }
  },
  mounted: function() {
    this.showOnThisDevice = this.device.isMobile;
    this.loading = false;
  },
};
</script>
<style></style>
